import { Component } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Dashbaord } from './dashbaord';
import { OpportunityService } from './opportunity.service';
import { MainWrapperComponent } from '@core/component';
import { AmplitudeService } from '@core/services'; // Adjust path as needed

@Component({
  selector: 'app-dashboard',
  imports: [
    CommonModule,
    DatePipe,
    MainWrapperComponent
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  oppportunityDetails: Dashbaord[] = [];
  sortField: string = '';
  sortDirection: 'asc' | 'desc' = 'desc';
  sortedOpportunities: any[] = [];

  constructor(
    private readonly _opportunityService: OpportunityService,
    private readonly _router: Router,
    private readonly _amplitudeService: AmplitudeService
  ) { }

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (token) {
      const userInfo = { access_token: token };
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    this._opportunityService.getOpportunity().subscribe((oppportunityDetails: Dashbaord[]) => {
      this.oppportunityDetails = oppportunityDetails.sort((a: any, b: any) => {
        if (new Date(a.updated_at) > new Date(b.updated_at)) {
          return -1;
        }
        return 1
      });
      this.sortedOpportunities = [...this.oppportunityDetails];
      this.sortBy('updated_at');
    });
  }

  openDeatilPage(oppportunityDetails: Dashbaord): void {
    const id = oppportunityDetails.opportunity_id;
    const opportunity_name = oppportunityDetails.opportunity_name;
    localStorage.setItem('OPPORTUNITY_NAME', opportunity_name);
    
    // Get user ID from session storage or your user service
    const userInfo = sessionStorage.getItem('userInfo');
    let userId = 'anonymous'; // Default fallback
    
    if (userInfo) {
      try {
        const parsedUserInfo = JSON.parse(userInfo);
        // Adjust this based on how your user ID is stored
        userId = parsedUserInfo.user_id || parsedUserInfo.id || 'anonymous';
      } catch (error) {
        console.warn('Error parsing user info for amplitude tracking:', error);
      }
    }

    // Track opportunity selection event with Amplitude
    if (id) {
      this._amplitudeService.trackEvent('opportunity_selection', {
        opportunity_id: id,
        user_id: userId
      });
    }

    if (id) {
      this._router.navigate(['/opportunity-detail', id, '']);
    }
  }

  createQuestion() {
    this._router.navigate(['/add-question']);
  }

  sortBy(field: string): void {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'desc';
    }

    this.sortedOpportunities = [...this.oppportunityDetails].sort((a: any, b: any) => {
      let aValue = a[field];
      let bValue = b[field];

      if (field === 'updated_at') {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      const result = aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      return this.sortDirection === 'asc' ? result : -result;
    });
  }
}